/**
 *  Color name formatter for Framework(Quasar)
 */
export const colorNameFormatter = type => {
  switch (type) {
    case 'primary':
      return 'primary';
    case 'secondary':
      return 'secondary';
    case 'accent':
      return 'accent';
    case 'dark':
      return 'dark';
    case 'success':
      return 'positive';
    case 'danger':
      return 'negative';
    case 'info':
      return 'info';
    case 'warning':
      return 'warning';
    default:
      return type;
  }
};
